import React, { useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import larrow from "../assets/clients/left-arrow.png";
import rarrow from "../assets/clients/right-arrow.png";
const images = [
  {
    src: require("../assets/clients/clients-1.png"),
  },
  {
    src: require("../assets/clients/clients-2.png"),
  },
  {
    src: require("../assets/clients/clients-3.png"),
  },
  {
    src: require("../assets/clients/clients-4.png"),
  },
  {
    src: require("../assets/clients/clients-5.png"),
  },
  {
    src: require("../assets/clients/clients-6.png"),
  },
  {
    src: require("../assets/clients/clients-7.png"),
  },
  {
    src: require("../assets/clients/clients-8.png"),
  },
  {
    src: require("../assets/clients/clients-9.png"),
  },
  {
    src: require("../assets/clients/clients-10.png"),
  },
  {
    src: require("../assets/clients/clients-11.png"),
  },
  {
    src: require("../assets/clients/clients-12.png"),
  },
  {
    src: require("../assets/clients/clients-13.png"),
  },
  {
    src: require("../assets/clients/clients-14.png"),
  },
  {
    src: require("../assets/clients/clients-15.png"),
  },
  {
    src: require("../assets/clients/clients-16.png"),
  },
  {
    src: require("../assets/clients/clients-17.png"),
  },
  {
    src: require("../assets/clients/clients-18.png"),
  },
  {
    src: require("../assets/clients/clients-19.png"),
  },
  {
    src: require("../assets/clients/clients-20.png"),
  },
  {
    src: require("../assets/clients/clients-21.png"),
  },
  {
    src: require("../assets/clients/clients-22.png"),
  },
  {
    src: require("../assets/clients/clients-23.png"),
  },
];

function ClientLogoSlider() {
  const sliderRef = useRef(null); // Reference for the slider

  const settings = {
    arrows: true,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 8,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,

    // 👇 Add these lines to enable 2 rows
    rows: 2,
    slidesPerRow: 1,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 8,
          rows: 2,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          rows: 2,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          rows: 2,
          slidesPerRow: 1,
        },
      },
    ],
  };

  const [activeSlide, setActiveSlide] = useState(0);

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  return (
    <>
      <div className="home-client-slider">
        <div className="slider-client client-logo-slider">
          <Slider ref={sliderRef} {...settings}>
            {images.map((image, i) => (
              <div className="client-logo-img">
                <div
                  key={i}
                  className={`slide ${i === activeSlide ? "zoom" : ""}`}
                  style={{ padding: "0 10px" }} // Add horizontal spacing
                >
                  <img
                    src={image.src}
                    alt={image.name}
                    className="slider-img-1"
                  />
                </div>
              </div>
            ))}
          </Slider>
          {/* <div className="slider-buttons">
          <img src={larrow} onClick={handlePrev} className="prev-button" />
          <img src={rarrow} onClick={handleNext} className="next-button" />
        </div> */}
        </div>
      </div>
    </>
  );
}

export default ClientLogoSlider;
